export enum ActorType {
  CUSTOMER = "CUSTOMER",
  NON_CUSTOMER = "NON-CUSTOMER",
}
export enum ActorTypeOLMap {
  CUSTOMER = "1",
  NON_CUSTOMER = "2",
}
